import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {NewTradingAlertDefinition, TradingAlertDefinition} from "../models/alert/TradingAlert";
import {AlertDialog} from "../components/alert-dialog/dialog/AlertDialogComponent";

export class TradingAlertDialogService {

    public static id = "tradingAlertDialogService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {

    }

    public async open(): Promise<NewTradingAlertDefinition>;
    public async open(alert: TradingAlertDefinition): Promise<TradingAlertDefinition>;

    public async open(alert?: TradingAlertDefinition): Promise<NewTradingAlertDefinition> {
        const options: IModalSettings = {
            component: AlertDialog,
            size: "md",
            windowClass: "fixed-height-modal",
            resolve: {
                alert: () => alert
            }
        };
        const alertModal = this.$uibModal.open(options);
        return await alertModal.result;
    }
}
